export const BIB__LOAD_DASHBOARD_TYPE_FAILED = `BIB__LOAD_DASHBOARD_TYPE_FAILED`;
export const BIB__LOAD_DASHBOARD_TYPE_FINISHED = `BIB__LOAD_DASHBOARD_TYPE_FINISHED`;
export const BIB__LOAD_DASHBOARD_TYPE_STARTED = `BIB__LOAD_DASHBOARD_TYPE_STARTED`;
export const BIB__SAVE_DASHBOARD_TYPE_FAILED = `BIB__SAVE_DASHBOARD_TYPE_FAILED`;
export const BIB__SAVE_DASHBOARD_TYPE_FINISHED = `BIB__SAVE_DASHBOARD_TYPE_FINISHED`;
export const BIB__SAVE_DASHBOARD_TYPE_STARTED = `BIB__SAVE_DASHBOARD_TYPE_STARTED`;
export const BIB__INDUSTRIES_LOADED = `BIB__INDUSTRIES_LOADED`;
export const BIB__LOAD_DASHBOARD_STACKS_FAILED = `BIB__LOAD_DASHBOARD_STACKS_FAILED`;
export const BIB__LOAD_DASHBOARD_STACKS_FINISHED = `BIB__LOAD_DASHBOARD_STACKS_FINISHED`;
export const BIB__LOAD_DASHBOARD_STACKS_STARTED = `BIB__LOAD_DASHBOARD_STACKS_STARTED`;
export const BUZZ__ADDED_ATTACHMENT_FAILED = `BUZZ__ADDED_ATTACHMENT_FAILED`;
export const BUZZ__ADDED_ATTACHMENT_FINISHED = `BUZZ__ADDED_ATTACHMENT_FINISHED`;
export const BUZZ__ADDED_ATTACHMENT_STARTED = `BUZZ__ADDED_ATTACHMENT_STARTED`;
export const BUZZ__ADDED_QUOTE_ATTACHMENT = `BUZZ__ADDED_QUOTE_ATTACHMENT`;
export const BUZZ__ALL_UNREADS_CLEARED = `BUZZ__ALL_UNREADS_CLEARED`;
export const BUZZ__AUTHOR_OBJECT_TARGETED = `BUZZ__AUTHOR_OBJECT_TARGETED`;
export const BUZZ__CARD_ATTACHED = `BUZZ__CARD_ATTACHED`;
export const BUZZ__CHANGED_BUZZ_INBOX_ROUTE = `BUZZ__CHANGED_BUZZ_INBOX_ROUTE`;
export const BUZZ__CHANGED_BUZZ_ROUTE = `BUZZ__CHANGED_BUZZ_ROUTE`;
export const BUZZ__CHANNEL_CREATED = `BUZZ__CHANNEL_CREATED`;
export const BUZZ__CHANNEL_LOADED = `BUZZ__CHANNEL_LOADED`;
export const BUZZ__CHANNELS_LOADED_BY_CARD_IDS = `BUZZ__CHANNELS_LOADED_BY_CARD_IDS`;
export const BUZZ__CHANNEL_LOADED_BY_PAGE_ID = `BUZZ__CHANNEL_LOADED_BY_PAGE_ID`;
export const BUZZ__CHANNEL_LOADED_BY_USER_ID = `BUZZ__CHANNEL_LOADED_BY_USER_ID`;
export const BUZZ__CHANNEL_LOADED_WITH_PEOPLE = `BUZZ__CHANNEL_LOADED_WITH_PEOPLE`;
export const BUZZ__CHANNEL_UNREADS_CLEARED = `BUZZ__CHANNEL_UNREADS_CLEARED`;
export const BUZZ__CLEARED_GRANT_PREVIEWS = `BUZZ__CLEARED_GRANT_PREVIEWS`;
export const BUZZ__COMPOSE_HUDDLE_CANCELLED = `BUZZ__COMPOSE_HUDDLE_CANCELLED`;
export const BUZZ__COMPOSE_HUDDLE_STARTED = `BUZZ__COMPOSE_HUDDLE_STARTED`;
export const BUZZ__CREATE_HUDDLE_FAILED = `BUZZ__CREATE_HUDDLE_FAILED`;
export const BUZZ__CREATE_HUDDLE_FINISHED = `BUZZ__CREATE_HUDDLE_FINISHED`;
export const BUZZ__CREATE_HUDDLE_STARTED = `BUZZ__CREATE_HUDDLE_STARTED`;
export const BUZZ__DELETE_MESSAGE_FAILED = `BUZZ__DELETE_MESSAGE_FAILED`;
export const BUZZ__DELETE_MESSAGE_FINISHED = `BUZZ__DELETE_MESSAGE_FINISHED`;
export const BUZZ__DELETE_MESSAGE_STARTED = `BUZZ__DELETE_MESSAGE_STARTED`;
export const BUZZ__FAVORITED_CHANNEL_BY_ID = `BUZZ__FAVORITED_CHANNEL_BY_ID`;
export const BUZZ__FAVORITES_LOADED = `BUZZ__FAVORITES_LOADED`;
export const BUZZ__FAVORITE_MESSAGE_FAILED = `BUZZ__FAVORITE_MESSAGE_FAILED`;
export const BUZZ__FAVORITE_MESSAGE_FINISHED = `BUZZ__FAVORITE_MESSAGE_FINISHED`;
export const BUZZ__FAVORITE_MESSAGE_STARTED = `BUZZ__FAVORITE_MESSAGE_STARTED`;
export const BUZZ__FLAT_MESSAGES_LOADED = `BUZZ__FLAT_MESSAGES_LOADED`;
export const BUZZ__FLAT_MESSAGES_LOADED_ALL_HUDDLE_MESSAGES = `BUZZ__FLAT_MESSAGES_LOADED_ALL_HUDDLE_MESSAGES`;
export const BUZZ__FLAT_MESSAGES_LOADED_ALL_MESSAGES = `BUZZ__FLAT_MESSAGES_LOADED_ALL_MESSAGES`;
export const BUZZ__HUDDLE_MESSAGE_CREATED_BY_SERVER = `BUZZ__HUDDLE_MESSAGE_CREATED_BY_SERVER`;
export const BUZZ__LOADED_ALL_CHANNELS = `BUZZ__LOADED_ALL_CHANNELS`;
export const BUZZ__LOADED_ATTACHMENTS = `BUZZ__LOADED_ATTACHMENTS`;
export const BUZZ__LOADED_CARD_TOPICS_BY_TITLE_SEARCH = `BUZZ__LOADED_CARD_TOPICS_BY_TITLE_SEARCH`;
export const BUZZ__LOADED_GENERAL_TOPICS_BY_TITLE_SEARCH = `BUZZ__LOADED_GENERAL_TOPICS_BY_TITLE_SEARCH`;
export const BUZZ__LOADED_GRANT_PREVIEWS = `BUZZ__LOADED_GRANT_PREVIEWS`;
export const BUZZ__LOADED_PAGE_TOPICS_BY_TITLE_SEARCH = `BUZZ__LOADED_PAGE_TOPICS_BY_TITLE_SEARCH`;
export const BUZZ__LOADED_PINNED_CHANNELS = `BUZZ__LOADED_PINNED_CHANNELS`;
export const BUZZ__LOADED_RECENT_ACTIVITY_TOPIC_CHANNELS = `BUZZ__LOADED_RECENT_ACTIVITY_TOPIC_CHANNELS`;
export const BUZZ__LOAD_CARD_TOPICS_BY_OFFSET_FAILED = `BUZZ__LOAD_CARD_TOPICS_BY_OFFSET_FAILED`;
export const BUZZ__LOAD_CARD_TOPICS_BY_OFFSET_FINISHED = `BUZZ__LOAD_CARD_TOPICS_BY_OFFSET_FINISHED`;
export const BUZZ__LOAD_CARD_TOPICS_BY_OFFSET_STARTED = `BUZZ__LOAD_CARD_TOPICS_BY_OFFSET_STARTED`;
export const BUZZ__LOAD_GENERAL_TOPICS_BY_OFFSET_FAILED = `BUZZ__LOAD_GENERAL_TOPICS_BY_OFFSET_FAILED`;
export const BUZZ__LOAD_GENERAL_TOPICS_BY_OFFSET_FINISHED = `BUZZ__LOAD_GENERAL_TOPICS_BY_OFFSET_FINISHED`;
export const BUZZ__LOAD_GENERAL_TOPICS_BY_OFFSET_STARTED = `BUZZ__LOAD_GENERAL_TOPICS_BY_OFFSET_STARTED`;
export const BUZZ__LOAD_HUDDLE_MESSAGES_FAILED = `BUZZ__LOAD_HUDDLE_MESSAGES_FAILED`;
export const BUZZ__LOAD_HUDDLE_MESSAGES_FINISHED = `BUZZ__LOAD_HUDDLE_MESSAGES_FINISHED`;
export const BUZZ__LOAD_HUDDLE_MESSAGES_STARTED = `BUZZ__LOAD_HUDDLE_MESSAGES_STARTED`;
export const BUZZ__LOAD_MESSAGES_STARTED = `BUZZ__LOAD_MESSAGES_STARTED`;
export const BUZZ__LOAD_MESSAGES_SUCCESS = `BUZZ__LOAD_MESSAGES_SUCCESS`;
export const BUZZ__LOAD_PAGE_TOPICS_BY_OFFSET_FAILED = `BUZZ__LOAD_PAGE_TOPICS_BY_OFFSET_FAILED`;
export const BUZZ__LOAD_PAGE_TOPICS_BY_OFFSET_FINISHED = `BUZZ__LOAD_PAGE_TOPICS_BY_OFFSET_FINISHED`;
export const BUZZ__LOAD_PAGE_TOPICS_BY_OFFSET_STARTED = `BUZZ__LOAD_PAGE_TOPICS_BY_OFFSET_STARTED`;
export const BUZZ__LOAD_ROUTE = `BUZZ__LOAD_ROUTE`;
export const BUZZ__MENTIONED_WITHOUT_PERMISSIONS = `BUZZ__MENTIONED_WITHOUT_PERMISSIONS`;
export const BUZZ__MESSAGE_BLURRED = `BUZZ__MESSAGE_BLURRED`;
export const BUZZ__MESSAGE_CREATED_BY_SERVER = `BUZZ__MESSAGE_CREATED_BY_SERVER`;
export const BUZZ__MESSAGE_LOADED = `BUZZ__MESSAGE_LOADED`;
export const BUZZ__MESSAGE_MENTION_CANCELLED = `BUZZ__MESSAGE_MENTION_CANCELLED`;
export const BUZZ__MESSAGE_MENTION_SEARCH_LOADED = `BUZZ__MESSAGE_MENTION_SEARCH_LOADED`;
export const BUZZ__MESSAGE_MENTION_STARTED = `BUZZ__MESSAGE_MENTION_STARTED`;
export const BUZZ__MESSAGE_REACTION_ADDED = `BUZZ__MESSAGE_REACTION_ADDED`;
export const BUZZ__MESSAGE_REACTION_REMOVED = `BUZZ__MESSAGE_REACTION_REMOVED`;
export const BUZZ__MESSAGE_RESET_PERMISSIONS = `BUZZ__MESSAGE_RESET_PERMISSIONS`;
export const BUZZ__MESSAGE_TAG_ADDED = `BUZZ__MESSAGE_TAG_ADDED`;
export const BUZZ__MESSAGE_TEXT_UPDATED = `BUZZ__MESSAGE_TEXT_UPDATED`;
export const BUZZ__MY_CHANNEL_UPDATED = `BUZZ__MY_CHANNEL_UPDATED`;
export const BUZZ__PINNED_CHANNEL_BY_ID = `BUZZ__PINNED_CHANNEL_BY_ID`;
export const BUZZ__PINNED_USERS_LOADED = `BUZZ__PINNED_USERS_LOADED`;
export const BUZZ__REMOVED_ATTACHMENT = `BUZZ__REMOVED_ATTACHMENT`;
export const BUZZ__REMOVED_QUOTE_ATTACHMENT = `BUZZ__REMOVED_QUOTE_ATTACHMENT`;
export const BUZZ__RESET_CHANNEL = `BUZZ__RESET_CHANNEL`;
export const BUZZ__UNFAVORITED_CHANNEL_BY_ID = `BUZZ__UNFAVORITED_CHANNEL_BY_ID`;
export const BUZZ__UNFAVORITE_MESSAGE_FAILED = `BUZZ__UNFAVORITE_MESSAGE_FAILED`;
export const BUZZ__UNFAVORITE_MESSAGE_FINISHED = `BUZZ__UNFAVORITE_MESSAGE_FINISHED`;
export const BUZZ__UNFAVORITE_MESSAGE_STARTED = `BUZZ__UNFAVORITE_MESSAGE_STARTED`;
export const BUZZ__UNPINNED_CHANNEL_BY_ID_FAILED = `BUZZ__UNPINNED_CHANNEL_BY_ID_FAILED`;
export const BUZZ__UNPINNED_CHANNEL_BY_ID_FINISHED = `BUZZ__UNPINNED_CHANNEL_BY_ID_FINISHED`;
export const BUZZ__UNPINNED_CHANNEL_BY_ID_STARTED = `BUZZ__UNPINNED_CHANNEL_BY_ID_STARTED`;
export const BUZZ__USER_AT_MENTIONED = `BUZZ__USER_AT_MENTIONED`;
export const BUZZ__USER_AT_MENTIONED_IN_HUDDLE = `BUZZ__USER_AT_MENTIONED_IN_HUDDLE`;
export const BUZZ__USER_CREATE_MESSAGE_ABANDONED = `BUZZ__USER_CREATE_MESSAGE_ABANDONED`;
export const BUZZ__USER_CREATE_MESSAGE_FAILED = `BUZZ__USER_CREATE_MESSAGE_FAILED`;
export const BUZZ__USER_CREATE_MESSAGE_FINISHED = `BUZZ__USER_CREATE_MESSAGE_FINISHED`;
export const BUZZ__USER_CREATE_MESSAGE_STARTED = `BUZZ__USER_CREATE_MESSAGE_STARTED`;
export const BUZZ__USER_PERMISSIONS_LOADED = `BUZZ__USER_PERMISSIONS_LOADED`;
export const CARD__ACCESS_DENIED = `CARD__ACCESS_DENIED`;
export const CARD__ADDED_FILTER = `CARD__ADDED_FILTER`;
export const CARD__APPLIED_FILTER = `CARD__APPLIED_FILTER`;
export const CARD__APPLIED_FILTER_GROUPS = `CARD__APPLIED_FILTER_GROUPS`;
export const CARD__CHART_RENDER = `CARD__CHART_RENDER`;
export const CARD__CLEARED_QUERYSTRING_ERROR = `CARD__CLEARED_QUERYSTRING_ERROR`;
export const CARD__COPY_FILTERS_FROM_PAGE_FINISHED = `CARD__COPY_FILTERS_FROM_PAGE_FINISHED`;
export const CARD__COPY_FILTERS_FROM_PAGE_STARTED = `CARD__COPY_FILTERS_FROM_PAGE_STARTED`;
export const CARD__DATE_GRAIN_UPDATED = `CARD__DATE_GRAIN_UPDATED`;
export const CARD__DATE_RANGE_UPDATED = `CARD__DATE_RANGE_UPDATED`;
export const CARD__EXPORT_DOWNLOAD_FAILED = `CARD__EXPORT_DOWNLOAD_FAILED`;
export const CARD__EXPORT_DOWNLOAD_FINISHED = `CARD__EXPORT_DOWNLOAD_FINISHED`;
export const CARD__EXPORT_DOWNLOAD_STARTED = `CARD__EXPORT_DOWNLOAD_STARTED`;
export const CARD__FILTERS_CLEARED = `CARD__FILTERS_CLEARED`;
export const CARD__GRANTED_ACCESS_TO_CARD = `CARD__GRANTED_ACCESS_TO_CARD`;
export const CARD__LOADED_CARD = `CARD__LOADED_CARD`;
export const CARD__LOADED_CARD_FAILED = `CARD__LOADED_CARD_FAILED`;
export const CARD__LOADED_CHART = `CARD__LOADED_CHART`;
export const CARD__LOADED_CHART_TABLE = `CARD__LOADED_CHART_TABLE`;
export const CARD__LOADED_DRILL_TABLE_VIEW = `CARD__LOADED_DRILL_TABLE_VIEW`;
export const CARD__LOADED_DRILL_VIEW = `CARD__LOADED_DRILL_VIEW`;
export const CARD__LOADED_INITIAL_CARD_FILTERS = `CARD__LOADED_INITIAL_CARD_FILTERS`;
export const CARD__LOADED_PDP_FILTERS = `CARD__LOADED_PDP_FILTERS`;
export const CARD__LOADED_QUERYSTRING_CARD_FILTERS = `CARD__LOADED_QUERYSTRING_CARD_FILTERS`;
export const CARD__LOADED_QUERYSTRING_CARD_FILTERS_FAILED = `CARD__LOADED_QUERYSTRING_CARD_FILTERS_FAILED`;
export const CARD__LOADED_QUERYSTRING_CARD_FILTERS_STARTED = `CARD__LOADED_QUERYSTRING_CARD_FILTERS_STARTED`;
export const CARD__LOADED_VALUES_FOR_COLUMN = `CARD__LOADED_VALUES_FOR_COLUMN`;
export const CARD__LOAD_FINISHED = `CARD__LOAD_FINISHED`;
export const CARD__LOAD_PAGE_FILTERS_FAILED = `CARD__LOAD_PAGE_FILTERS_FAILED`;
export const CARD__LOAD_PAGE_FILTERS_FINISHED = `CARD__LOAD_PAGE_FILTERS_FINISHED`;
export const CARD__LOAD_PAGE_FILTERS_STARTED = `CARD__LOAD_PAGE_FILTERS_STARTED`;
export const CARD__LOAD_QUERYSTRING_PAGE_FILTERS_FAILED = `CARD__LOAD_QUERYSTRING_PAGE_FILTERS_FAILED`;
export const CARD__LOAD_QUERYSTRING_PAGE_FILTERS_FINISHED = `CARD__LOAD_QUERYSTRING_PAGE_FILTERS_FINISHED`;
export const CARD__LOAD_QUERYSTRING_PAGE_FILTERS_STARTED = `CARD__LOAD_QUERYSTRING_PAGE_FILTERS_STARTED`;
export const CARD__LOAD_STATE_FROM_VIEW_FINISHED = `CARD__LOAD_STATE_FROM_VIEW_FINISHED`;
export const CARD__LOAD_STATE_FROM_VIEW_STARTED = `CARD__LOAD_STATE_FROM_VIEW_STARTED`;
export const CARD__REMOVED_FILTER = `CARD__REMOVED_FILTER`;
export const CARD__RESET_STATE = `CARD__RESET_STATE`;
export const CARD__SAVE_FINISHED = `CARD__SAVE_FINISHED`;
export const CARD__SELECTED_PDP_FILTERS = `CARD__SELECTED_PDP_FILTERS`;
export const CARD__SETTINGS_LOADED = `CARD__SETTINGS_LOADED`;
export const CARD__SET_CHART_DATE_RANGE = `CARD__SET_CHART_DATE_RANGE`;
export const CARD__SET_CHART_GRAIN = `CARD__SET_CHART_GRAIN`;
export const CARD__STATISTICS_LOADED = `CARD__STATISTICS_LOADED`;
export const CARD__NOTEBOOK_LOADED = `CARD__NOTEBOOK_LOADED`;
export const CHART__STATE_UPDATED = `CHART__STATE_UPDATED`;
export const DATASOURCE__LOADED_BY_CARD_ID = `DATASOURCE__LOADED_BY_CARD_ID`;
export const DATASOURCE__LOADED_PDP_FILTER_GROUPS = `DATASOURCE__LOADED_PDP_FILTER_GROUPS`;
export const DOCUMENT__LOADED_DETAILS = `DOCUMENT__LOADED_DETAILS`;
export const ENVIRONMENT__BEGAN_TRIAL_FAILED = `ENVIRONMENT__BEGAN_TRIAL_FAILED`;
export const ENVIRONMENT__BEGAN_TRIAL_FINISHED = `ENVIRONMENT__BEGAN_TRIAL_FINISHED`;
export const ENVIRONMENT__BEGAN_TRIAL_STARTED = `ENVIRONMENT__BEGAN_TRIAL_STARTED`;
export const ENVIRONMENT__LOAD_ENVIRONMENT_FAILED = `ENVIRONMENT__LOAD_ENVIRONMENT_FAILED`;
export const ENVIRONMENT__LOAD_ENVIRONMENT_FINISHED = `ENVIRONMENT__LOAD_ENVIRONMENT_FINISHED`;
export const ENVIRONMENT__LOAD_ENVIRONMENT_STARTED = `ENVIRONMENT__LOAD_ENVIRONMENT_STARTED`;
export const ENVIRONMENT__ONLINE_STATUS_HEARTBEAT_SENT = `ENVIRONMENT__ONLINE_STATUS_HEARTBEAT_SENT`;
export const ENVIRONMENT__REQUEST_UPGRADE_FAILED = `ENVIRONMENT__REQUEST_UPGRADE_FAILED`;
export const ENVIRONMENT__REQUEST_UPGRADE_FINISHED = `ENVIRONMENT__REQUEST_UPGRADE_FINISHED`;
export const ENVIRONMENT__REQUEST_UPGRADE_STARTED = `ENVIRONMENT__REQUEST_UPGRADE_STARTED`;
export const ENVIRONMENT__TRIAL_STATUS_LOADED = `ENVIRONMENT__TRIAL_STATUS_LOADED`;
export const FAVORITE__FAVORITED_CARD = `FAVORITE__FAVORITED_CARD`;
export const FAVORITE__UNFAVORITED_CARD = `FAVORITE__UNFAVORITED_CARD`;
export const FEATURE__FEATURES_ENABLED_BY_SESSION = `FEATURE__FEATURES_ENABLED_BY_SESSION`;
export const FEATURE__FEATURES_ENABLED_BY_SWITCHER = `FEATURE__FEATURES_ENABLED_BY_SWITCHER`;
export const FEATURE__FEATURES_ENABLED_BY_URL = `FEATURE__FEATURES_ENABLED_BY_URL`;
export const FEATURE__FEATURES_LOADED_BY_SESSION = `FEATURE__FEATURES_LOADED_BY_SESSION`;
export const FEATURE__FEATURES_LOADED_BY_SWITCHER = `FEATURE__FEATURES_LOADED_BY_SWITCHER`;
export const FEATURE__FEATURES_LOADED_BY_URL = `FEATURE__FEATURES_LOADED_BY_URL`;
export const FEATURE__LOAD_FEATURES_FAILED = `FEATURE__LOAD_FEATURES_FAILED`;
export const FEATURE__LOAD_FEATURES_FINISHED = `FEATURE__LOAD_FEATURES_FINISHED`;
export const FEATURE__LOAD_FEATURES_STARTED = `FEATURE__LOAD_FEATURES_STARTED`;
export const GUIDE__SECTION_COMPLETED = `GUIDE__SECTION_COMPLETED`;
export const GUIDE__STATE_LOADED = `GUIDE__STATE_LOADED`;
export const GUIDE__STEP_OPENED = `GUIDE__STEP_OPENED`;
export const GUIDE__LOAD_FINISHED = `GUIDE__LOAD_FINISHED`;
export const GUIDE__FULFILLED = `GUIDE__FULFILLED`;
export const HOME__NAVIGATION_ITEM_ADDED = `HOME__NAVIGATION_ITEM_ADDED`;
export const HOME__NAVIGATION_ITEM_REMOVED = `HOME__NAVIGATION_ITEM_REMOVED`;
export const HOME__NAVIGATION_LOAD_FAILED = `HOME__NAVIGATION_LOAD_FAILED`;
export const HOME__NAVIGATION_LOAD_FINISHED = `HOME__NAVIGATION_LOAD_FINISHED`;
export const HOME__NAVIGATION_LOAD_STARTED = `HOME__NAVIGATION_LOAD_STARTED`;
export const HOME__NAVIGATION_SAVED = `HOME__NAVIGATION_SAVED`;
export const HOME__REORDER_NAVIGATION = `HOME__REORDER_NAVIGATION`;
export const HOME__TREND_LOAD_FAILED = `HOME__TREND_LOAD_FAILED`;
export const HOME__TREND_LOAD_FINISHED = `HOME__TREND_LOAD_FINISHED`;
export const HOME__TREND_LOAD_STARTED = `HOME__TREND_LOAD_STARTED`;
export const HOME__VIEW_COUNTS_LOADED = `HOME__VIEW_COUNTS_LOADED`;
export const INVITE__DISPLAY_NAME_UPDATED = `INVITE__DISPLAY_NAME_UPDATED`;
export const INVITE__EMAIL_DUPLICATED = `INVITE__EMAIL_DUPLICATED`;
export const INVITE__EMAIL_UPDATED = `INVITE__EMAIL_UPDATED`;
export const INVITE__RESET = `INVITE__RESET`;
export const INVITE__SUBMIT_FAILED = `INVITE__SUBMIT_FAILED`;
export const INVITE__SUBMIT_FINISHED = `INVITE__SUBMIT_FINISHED`;
export const INVITE__SUBMIT_STARTED = `INVITE__SUBMIT_STARTED`;
export const LAYOUT_FRAME__LOAD_FINISHED = `LAYOUT_FRAME__LOAD_FINISHED`;
export const NAVIGATION__LOADED_EXTERNAL_PAGE_NAVIGATION = `NAVIGATION__LOADED_EXTERNAL_PAGE_NAVIGATION`;
export const NAVIGATION__LOADED_PAGE_NAVIGATION = `NAVIGATION__LOADED_PAGE_NAVIGATION`;
export const NAVIGATION__SET_CARDS_SECTION_ACTIVE = `NAVIGATION__SET_CARDS_SECTION_ACTIVE`;
export const NAVIGATION__SET_DAILY_DOMO_SECTION_ACTIVE = `NAVIGATION__SET_DAILY_DOMO_SECTION_ACTIVE`;
export const NAVIGATION__SET_DOMOBUZZ__SECTION_ACTIVE = `NAVIGATION__SET_DOMOBUZZ__SECTION_ACTIVE`;
export const NAVIGATION__SET_HOME_SECTION_ACTIVE = `NAVIGATION__SET_HOME_SECTION_ACTIVE`;
export const NAVIGATION__SET_MORE_SECTION_ACTIVE = `NAVIGATION__SET_MORE_SECTION_ACTIVE`;
export const NAVIGATION__SET_NOTIFICATIONS_SECTION_ACTIVE = `NAVIGATION__SET_NOTIFICATIONS_SECTION_ACTIVE`;
export const NAVIGATION__SET_PEOPLE_SECTION_ACTIVE = `NAVIGATION__SET_PEOPLE_SECTION_ACTIVE`;
export const NAVIGATION__SET_SEARCH_SECTION_ACTIVE = `NAVIGATION__SET_SEARCH_SECTION_ACTIVE`;
export const NOTIFICATION__LOADED_NOTIFICATIONS = `NOTIFICATION__LOADED_NOTIFICATIONS`;
export const NOTIFICATION__LOADED_NOTIFICATIONS_FAILED = `NOTIFICATION__LOADED_NOTIFICATIONS_FAILED`;
export const NOTIFICATION__LOADED_NOTIFICATIONS_LAST_SEEN = `NOTIFICATION__LOADED_NOTIFICATIONS_LAST_SEEN`;
export const NOTIFICATION__LOADED_NOTIFICATIONS_STARTED = `NOTIFICATION__LOADED_NOTIFICATIONS_STARTED`;
export const NOTIFICATION__MARKED_UNSEEN_NOTIFICATIONS = `NOTIFICATION__MARKED_UNSEEN_NOTIFICATIONS`;
export const NOTIFICATION_SETTINGS__LOADED_BUZZ_SETTINGS = `NOTIFICATION_SETTINGS__LOADED_BUZZ_SETTINGS`;
export const NOTIFICATION_SETTINGS__LOADED_PRODUCTIVITY_SETTINGS = `NOTIFICATION_SETTINGS__LOADED_PRODUCTIVITY_SETTINGS`;
export const NOTIFICATION_SETTINGS__BUZZ_SETTINGS_UPDATED = `NOTIFICATION_SETTINGS__BUZZ_SETTINGS_UPDATED`;
export const NOTIFICATION_SETTINGS__PRODUCTIVITY_SETTINGS_UPDATED = `NOTIFICATION_SETTINGS__PRODUCTIVITY_SETTINGS_UPDATED`;
export const PEOPLE__FOLLOWED_PERSON = `PEOPLE__FOLLOWED_PERSON`;
export const PEOPLE__LOADED_ALL_PEOPLE = `PEOPLE__LOADED_ALL_PEOPLE`;
export const PEOPLE__LOADED_FOLLOWING = `PEOPLE__LOADED_FOLLOWING`;
export const PEOPLE__LOADED_GROUP = `PEOPLE__LOADED_GROUP`;
export const PEOPLE__LOADED_GROUPS = `PEOPLE__LOADED_GROUPS`;
export const PEOPLE__LOADED_PROFILE = `PEOPLE__LOADED_PROFILE`;
export const PEOPLE__LOADED_PROFILE_STATISTICS = `PEOPLE__LOADED_PROFILE_STATISTICS`;
export const PEOPLE__LOADED_TEAM = `PEOPLE__LOADED_TEAM`;
export const PEOPLE__PROFILE_LOADED = `PEOPLE__PROFILE_LOADED`;
export const PEOPLE__PROFILE_EDIT_STARTED = `PEOPLE__PROFILE_EDIT_STARTED`;
export const PEOPLE__PROFILE_EDIT_FINISHED = `PEOPLE__PROFILE_EDIT_FINISHED`;
export const PEOPLE__PROFILE_STATISTICS_LOADED = `PEOPLE__PROFILE_STATISTICS_LOADED`;
export const PEOPLE__SEARCH = `PEOPLE__SEARCH`;
export const PEOPLE__SEARCH_RESET = `PEOPLE__SEARCH_RESET`;
export const PEOPLE__SEARCH_RESULTS = `PEOPLE__SEARCH_RESULTS`;
export const PEOPLE__UNFOLLOWED_PERSON = `PEOPLE__UNFOLLOWED_PERSON`;
export const POLL__VOTED = `POLL__VOTED`;
export const POLL__LOADED = `POLL__LOADED`;
export const PREFERENCE__LOADED_PREFERENCES = `PREFERENCE__LOADED_PREFERENCES`;
export const PREFERENCE__SAVED_PREFERENCES = `PREFERENCE__SAVED_PREFERENCES`;
export const SEARCH__CURRENT_FACET_CLEARED = `SEARCH__CURRENT_FACET_CLEARED`;
export const SEARCH__CURRENT_FACET_SET = `SEARCH__CURRENT_FACET_SET`;
export const SEARCH__ENTITY_CLEARED = `SEARCH__ENTITY_CLEARED `;
export const SEARCH__ENTITY_SET = `SEARCH__ENTITY_SET `;
export const SEARCH__EXECUTED_SEARCH_CARDS = `SEARCH__EXECUTED_SEARCH_CARDS`;
export const SEARCH__EXECUTED_SEARCH_DOMOBUZZ = `SEARCH__EXECUTED_SEARCH_DOMOBUZZ`;
export const SEARCH__EXECUTED_SEARCH_PAGES = `SEARCH__EXECUTED_SEARCH_PAGES`;
export const SEARCH__EXECUTED_SEARCH_USERS_AND_GROUPS = `SEARCH__EXECUTED_SEARCH_USERS_AND_GROUPS`;
export const SEARCH__FILTERS_CLEARED = `SEARCH__FILTERS_CLEARED`;
export const SEARCH__FILTER_ADDED = `SEARCH__FILTER_ADDED`;
export const SEARCH__FILTER_CLEARED = `SEARCH__FILTER_CLEARED`;
export const SEARCH__FILTER_OPEN_TOGGLED = `SEARCH__FILTER_OPEN_TOGGLED`;
export const SEARCH__QUERY_FAILED = `SEARCH__QUERY_FAILED `;
export const SEARCH__QUERY_FINISHED = `SEARCH__QUERY_FINISHED `;
export const SEARCH__QUERY_STARTED = `SEARCH__QUERY_STARTED`;
export const SEARCH__RESET_SEARCH = `SEARCH__RESET_SEARCH`;
export const SEARCH__SELECTED_SEARCH_RESULT = `SEARCH__SELECTED_SEARCH_RESULT`;
export const SEARCH__SET_RECENT = `SEARCH__SET_RECENT`;
export const SEARCH__SET_SEARCH_CARDS_LIMIT = `SEARCH__SET_SEARCH_CARDS_LIMIT`;
export const SEARCH__SET_SEARCH_USERS_AND_GROUPS_LIMIT = `SEARCH__SET_SEARCH_USERS_AND_GROUPS_LIMIT`;
export const STACK__ACCESS_REQUESTED = `STACK__ACCESS_REQUESTED`;
export const STACK__ADDED_PAGE_FILTER = `STACK__ADDED_PAGE_FILTER`;
export const STACK__APPLIED_PAGE_FILTER = `STACK__APPLIED_PAGE_FILTER`;
export const STACK__CLEARED_QUERYSTRING_ERROR = `STACK__CLEARED_QUERYSTRING_ERROR`;
export const STACK__GRANTED_ACCESS_TO_STACK = `STACK__GRANTED_ACCESS_TO_STACK`;
export const STACK__LOADED_STACK = `STACK__LOADED_STACK`;
export const STACK__LOAD_BY_ID_ACCESS_DENIED = `STACK__LOAD_BY_ID_ACCESS_DENIED`;
export const STACK__LOAD_BY_ID_FAILED = `STACK__LOAD_BY_ID_FAILED`;
export const STACK__LOAD_BY_ID_FINISHED = `STACK__LOAD_BY_ID_FINISHED`;
export const STACK__LOAD_BY_ID_STARTED = `STACK__LOAD_BY_ID_STARTED`;
export const STACK__PAGE_FILTERS_SAVED = `STACK__PAGE_FILTERS_SAVED`;
export const STACK__POWER_UP_ASSIGNED = `STACK__POWER_UP_ASSIGNED`;
export const STACK__REMOVED_PAGE_FILTER = `STACK__REMOVED_PAGE_FILTER`;
export const USER__CARD_STATISTICS_LOADED = `USER__CARD_STATISTICS_LOADED`;
export const USER__LOAD_ALL_USERS_FINISHED = `USER__LOAD_ALL_USERS_FINISHED`;
export const USER__LOAD_ALL_USERS_STARTED = `USER__LOAD_ALL_USERS_STARTED`;
export const USER__LOAD_USERS_DETAILS_FAILED = `USER__LOAD_USERS_DETAILS_FAILED`;
export const USER__LOAD_USERS_DETAILS_FINISHED = `USER__LOAD_USERS_DETAILS_FINISHED`;
export const USER__LOAD_USERS_DETAILS_STARTED = `USER__LOAD_USERS_DETAILS_STARTED`;
export const USER__LOAD_USERS_FAILED = `USER__LOAD_USERS_FAILED`;
export const USER__LOAD_USERS_FINISHED = `USER__LOAD_USERS_FINISHED`;
export const USER__LOAD_USERS_STARTED = `USER__LOAD_USERS_STARTED`;
export const VIEW__LOAD_FINISHED = `VIEW__LOAD_FINISHED`;
export const VIEW__LOAD_STARTED = `VIEW__LOAD_STARTED`;
export const THEME__LOAD_FINISHED = `THEME__LOAD_FINISHED`;
export const VIEWPORT__CHANGED = `VIEWPORT__CHANGED`;

export const CARD__CHART_PICKER_ACTIVATED = 'CARD__CHART_PICKER_ACTIVATED';
export const CARD__CHART_PICKER_DEACTIVATED = 'CARD__CHART_PICKER_DEACTIVATED';
export const CARD__TABLE_ACTIVATED = 'CARD__TABLE_ACTIVATED';
export const CARD__TABLE_DEACTIVATED = 'CARD__TABLE_DEACTIVATED';
export const CARD__FILTER_ACTIVATED = 'CARD__FILTER_ACTIVATED';
export const CARD__FILTER_DEACTIVATED = 'CARD__FILTER_DEACTIVATED';
export const CARD__FEATURES_LOADED = 'CARD__FEATURES_LOADED';

export const SHARE__CARD_SHARES_LOADED = 'SHARE__CARD_SHARES_LOADED';

export const RPC__FILTERS_APPLIED = 'RPC__FILTERS_APPLIED';
